import {ICrmbLeadHistoricoCleanDTO, ICrmbLeadHistoricoDTO, ICrmbLeadHistoricoFullDTO,
} from '../models/happy-code-api.model';
import { baseFindList } from './base/base-find-list.service';
import { baseFind } from './base/base-find.service';

export const useLeadHistoricoService = () => {
	const resourceURL = 'crmb/lead-historico';

	return {
		...baseFindList<ICrmbLeadHistoricoCleanDTO, ICrmbLeadHistoricoDTO, ICrmbLeadHistoricoFullDTO>(resourceURL),
		...baseFind<ICrmbLeadHistoricoCleanDTO, ICrmbLeadHistoricoDTO, ICrmbLeadHistoricoFullDTO>(resourceURL),
	};
};
